const firebaseConfig = {
    apiKey: "AIzaSyDOAvjZ2cTt4fiKN49exdBQ1KRNlKwSHSA",
    authDomain: "assignment12-fd267.firebaseapp.com",
    projectId: "assignment12-fd267",
    storageBucket: "assignment12-fd267.appspot.com",
    messagingSenderId: "862524825306",
    appId: "1:862524825306:web:c3d220ebd17cb893f98fe3",
    measurementId: "G-RE4T3V8WZ1"
};
export default firebaseConfig;